import React from 'react'
import { PersonBlock } from '@fs/zion-ui'
import AccessControl from './AccessControl'
import { PersonLink, TreePersonLink } from '../../app/Links'
import DmcCopyToClipboardTooltip from '../../../util/DmcCopyToClipboardTooltip'

export default function PersonInfo({ person, accessControls, isTreeLink = false, showId = false }) {
  const hasActiveAccessControl = () => {
    if (accessControls && accessControls[person.personId]) {
      const accessControl = accessControls[person.personId]
      return (
        accessControl.hidden ||
        accessControl.locked ||
        accessControl.ownerRestricted ||
        accessControl.hideCompletedOrdinances ||
        accessControl.ordinanceApprovalRequired ||
        accessControl.unpublished
      )
    }
    return false
  }

  return (
    <PersonBlock
      size="sm"
      avatarProps={{
        sex: `${person.gender?.toLowerCase()}`,
      }}
      name={
        isTreeLink ? (
          <TreePersonLink newTab personId={person.personId || person.id} personName={person.name} showId={showId} />
        ) : (
          <PersonLink personId={person.personId || person.id} personName={person.name} showId={showId} />
        )
      }
      details={
        <>
          <DmcCopyToClipboardTooltip nextToText value={person.personId || person.id} />
          {person.lifespan && person.lifespan !== '' && person.lifespan !== '-' && (
            <span>&nbsp;•&nbsp;{person.lifespan}</span>
          )}
          {hasActiveAccessControl() && (
            <span>
              &nbsp;•&nbsp;
              <AccessControl accessControl={accessControls[person.personId]} />
            </span>
          )}
        </>
      }
    />
  )
}
